/** @jsx h */
import { labels, queries, searchType } from '../config';
import FilterAccordion from './Facets/FilterAccordion';
import QueryCheckbox from './Facets/QueryCheckbox';
import { Fragment } from 'preact';
import FilterCheckbox from './Facets/FilterCheckbox';

const FilterContainer = ({
  facets,
  facetsActive,
  triggerAjaxSubmit,
  setPopularSearchTermAsInputQuery,
  pluginNamespace,
  isMainSearch,
  handleReset,
  isReset,
  inputQuery,
  currentEndpoint,
  resultIsEmpty,
}) => {
  // show facets as accordion only if
  // - there is more than one facet
  // - and there are any facet options
  function showFacetAsAccordion(facet) {
    return facets.length > 1 && facet.options?.length > 0;
  }

  function showFacet(facet) {
    if (facetsActive.length > 0) {
      const activeFacetIsNetworkFacet = facetsActive[0].isNetworkFacet;
      return (
        facet.isNetworkFacet === activeFacetIsNetworkFacet && !facet.hidden
      );
    } else {
      return !facet.hidden;
    }
  }

  // show popular search terms only
  // - in partial search "experiments" (searchType === 'experiments')
  // - in global search > endpoint experiments (currentEndpoint.label === 'Experimente'
  // - and if there are any search terms
  function showPopularSearchTerms() {
    return (
      queries?.length > 0 &&
      (currentEndpoint?.label === 'Experimente' || searchType === 'experiments')
    );
  }

  return (
    <div className="filter">
      {searchType ? (
        <input
          type="hidden"
          name={`${pluginNamespace}[searchType]`}
          value={`${searchType}`}
        />
      ) : (
        ''
      )}
      {facets?.length ? (
        <Fragment>
          {facets.map((facet, index) =>
            !resultIsEmpty && showFacet(facet) && facet.type === 'dateRange' ? (
              <fieldset className="filter__fieldset" key={index}>
                <FilterAccordion
                  facet={facet}
                  triggerAjaxSubmit={triggerAjaxSubmit}
                  pluginNamespace={pluginNamespace}
                  isMainSearch={isMainSearch}
                  isReset={isReset}
                />
              </fieldset>
            ) : !resultIsEmpty && showFacet(facet) && facet.type === 'input' ? (
              <fieldset className="filter__fieldset" key={index}>
                <FilterAccordion
                  facet={facet}
                  triggerAjaxSubmit={triggerAjaxSubmit}
                  pluginNamespace={pluginNamespace}
                  isMainSearch={isMainSearch}
                  isReset={isReset}
                />
              </fieldset>
            ) : showFacet(facet) &&
              showFacetAsAccordion(facet) &&
              facet.type !== 'nonAccordion' ? (
              <fieldset className="filter__fieldset" key={index}>
                <FilterAccordion
                  facet={facet}
                  triggerAjaxSubmit={triggerAjaxSubmit}
                  pluginNamespace={pluginNamespace}
                  isMainSearch={isMainSearch}
                  isReset={isReset}
                />
              </fieldset>
            ) : facet.options.length > 0 && showFacet(facet) ? (
              <fieldset className="filter__fieldset" key={index}>
                <legend className="filter__legend text">
                  <span>
                    {facet.type === 'nonAccordion'
                      ? facet.label
                      : labels.faceting.defaultLabel}
                  </span>
                </legend>
                <div className="filter__options">
                  <ul className="filter__list">
                    {facet.options.map(option => (
                      <li className="filter__item" key={option.value}>
                        <FilterCheckbox
                          option={option}
                          filterName={facet.name}
                          handleChange={triggerAjaxSubmit}
                          pluginNamespace={pluginNamespace}
                          isMainSearch={isMainSearch}
                        />
                      </li>
                    ))}
                  </ul>
                </div>
              </fieldset>
            ) : (
              ''
            )
          )}
          {showPopularSearchTerms() ? (
            <fieldset className="filter__fieldset">
              <Fragment>
                <legend className="filter__legend text">
                  <span>{labels.search.popularSearchTerms}</span>
                </legend>
                <div className="filter__options">
                  <ul className="filter__list filter__options-inner">
                    {queries.map((query, index) =>
                      query.label.length ? (
                        <QueryCheckbox
                          key={index}
                          label={query.label}
                          setPopularSearchTermAsInputQuery={
                            setPopularSearchTermAsInputQuery
                          }
                          handleReset={handleReset}
                          pluginNamespace={pluginNamespace}
                          isMainSearch={isMainSearch}
                          inputQuery={inputQuery}
                        />
                      ) : (
                        ''
                      )
                    )}
                  </ul>
                </div>
              </Fragment>
            </fieldset>
          ) : (
            ''
          )}
        </Fragment>
      ) : (
        ''
      )}

      <button className="filter__reset text" type="reset" onClick={handleReset}>
        <span>{labels.faceting.removeAllFilters}</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="svg-close"
          viewBox="0 0 22.02 22.02"
          aria-hidden="true"
        >
          <path
            fill="currentColor"
            d="m12.71 11.01 8.96-8.96a1.201 1.201 0 1 0-1.7-1.7l-8.96 8.96L2.05.35a1.201 1.201 0 1 0-1.7 1.7l8.96 8.96-8.96 8.96a1.201 1.201 0 1 0 1.7 1.7l8.96-8.96 8.96 8.96a1.204 1.204 0 0 0 1.7 0c.47-.47.47-1.23 0-1.7l-8.96-8.96Z"
          />
        </svg>
      </button>
    </div>
  );
};

export default FilterContainer;
